import { NgModule } from '@angular/core'
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router'
import { IndexPageComponent } from './shared-pages/index-page/index-page.component'
import { SignUpPageComponent } from './shared-pages/sign-up-page/sign-up-page.component'
import { SignInPageComponent } from './shared-pages/sign-in-page/sign-in-page.component'
import { SharedPagesModule } from './shared-pages/shared-pages.module'
import { ParkingMapSearchPageComponent } from './shared-pages/parking-map-search-page/parking-map-search-page.component'
import { ParkingPageComponent } from './shared-pages/parking-page/parking-page.component'
import { ForgotPasswordPageComponent } from './shared-pages/forgot-password-page/forgot-password-page.component'
import { map } from 'rxjs/operators'
import firebase from 'firebase/compat'
import { AuthGuard } from '@angular/fire/auth-guard'
import { PaygateResultPageComponent } from './shared-pages/paygate/paygate-result-page/paygate-result-page.component'
import { PaygateRequestComponent } from './shared-pages/paygate/paygate-request/paygate-request.component'
import { EttiquettePageComponent } from './shared-pages/ettiquette-page/ettiquette-page.component'
import { TermsAndConditionsPageComponent } from './shared-pages/terms-and-conditions-page/terms-and-conditions-page.component'
import { PrivacyPageComponent } from './shared-pages/privacy-page/privacy-page.component'
import { SafetyAndTrustPageComponent } from './shared-pages/safety-and-trust-page/safety-and-trust-page.component'
import { FaqsPageComponent } from './shared-pages/faqs-page/faqs-page.component'
import { AboutUsPageComponent } from './shared-pages/about-us-page/about-us-page.component'
import { ContactPageComponent } from './shared-pages/contact-page/contact-page.component'
import { DataDeletionComponent } from './shared-pages/data-deletion/data-deletion.component'
import { AboutCollectorComponent } from './shared-pages/about-collector/about-collector.component'
import { BlogListPageComponent } from './shared-pages/blog-list-page/blog-list-page.component'
import { BlogPageComponent } from './shared-pages/blog-page/blog-page.component'
import { CartPageComponent } from './core/shared-pages/cart-page/cart-page.component'
import { BookingThankYouPageComponent } from './shared-pages/booking-thank-you-page/booking-thank-you-page.component'
import { CorporatePageComponent } from './shared-pages/corporate-page/corporate-page.component'
import { VerifyEmailPageComponent } from './shared-pages/verify-email-page/verify-email-page.component'
import { WhitelabelComponent } from './shared-pages/whitelabel/whitelabel.component'
import { BookuppInfoPageComponent } from './shared-pages/bookupp-info-page/bookupp-info-page.component'
import { FaqsPageBookuppComponent } from './shared-pages/faqs-page-bookupp/faqs-page-bookupp.component'
import { ContactPageBookuppComponent } from './shared-pages/contact-page-bookupp/contact-page-bookupp.component'
import { BookuppFaqPageComponent } from './shared-pages/bookupp-faq-page/bookupp-faq-page.component'
import { HowItWorksComponent } from './shared-pages/how-it-works/how-it-works.component'
import User = firebase.User

const redirectAuthorisedToHome = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => map((user: User) => (!user || user.isAnonymous ? true : ''))

const routes: Routes = [
    { path: '', component: IndexPageComponent },
    { path: 'sign-up', component: SignUpPageComponent, canActivate: [AuthGuard], data: { authGuardPipe: redirectAuthorisedToHome } },
    { path: 'sign-in', component: SignInPageComponent, canActivate: [AuthGuard], data: { authGuardPipe: redirectAuthorisedToHome } },
    { path: 'forgot-password', component: ForgotPasswordPageComponent, canActivate: [AuthGuard], data: { authGuardPipe: redirectAuthorisedToHome } },
    { path: 'verify-email/:clientKey/:token', component: VerifyEmailPageComponent },
    { path: 'map-search', component: ParkingMapSearchPageComponent },
    { path: 'parking/:parkingKey', component: ParkingPageComponent },
    { path: 'paygate-request', component: PaygateRequestComponent },
    { path: 'paygate-result', component: PaygateResultPageComponent },
    { path: 'ettiquette', component: EttiquettePageComponent },
    { path: 'terms-and-conditions', component: TermsAndConditionsPageComponent },
    { path: 'privacy', component: PrivacyPageComponent },
    { path: 'safety-and-trust', component: SafetyAndTrustPageComponent },
    { path: 'bookupp', component: BookuppInfoPageComponent },
    { path: 'bookupp/:status', component: BookuppInfoPageComponent },
    { path: 'bookupp-faqs', component: BookuppFaqPageComponent },
    { path: 'bookupp-faqs/:status', component: BookuppFaqPageComponent },
    { path: 'corporate', component: CorporatePageComponent },
    { path: 'corporate/:status', component: CorporatePageComponent },
    { path: 'contact', component: ContactPageComponent },
    { path: 'contact/:status', component: ContactPageComponent },
    { path: 'contact-bookupp', component: ContactPageBookuppComponent },
    { path: 'how-it-works', component: HowItWorksComponent },
    { path: 'faqs', component: FaqsPageComponent },
    { path: 'how-it-works-bookupp', component: FaqsPageBookuppComponent },
    { path: 'about-us', component: AboutUsPageComponent },
    { path: 'data-deletion', component: DataDeletionComponent },
    { path: 'about-collector', component: AboutCollectorComponent },
    { path: 'news', component: BlogListPageComponent },
    { path: 'blog/:blogKey', component: BlogPageComponent },
    { path: 'cart/:subscriptionKey', component: CartPageComponent },
    { path: 'thank-you-booking', component: BookingThankYouPageComponent },
    { path: 'showcase', component: WhitelabelComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes), SharedPagesModule],
    exports: [RouterModule],
    providers: [],
})
export class SharedRoutingModule {}
